// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"478":"46992c44","557":"651b2fc4","600":"fd875439","829":"e827047c"}[chunkId] + ".js";
};